export const FEATURE_GATE_UPLOAD_AND_PRINT_PROGRESSIVE_VALIDATION = 'upload_and_print_progressive_validation';
